import { useEffect, useState } from 'react';
import { kml as toGeoJsonKml } from '@tmcw/togeojson';
import type { FeatureCollection } from 'geojson';

export function useKmlLayer(url: string): FeatureCollection | null {
  const [geojson, setGeojson] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const res = await fetch(url);
      if (!res.ok) return;

      let kmlText: string;

      if (url.toLowerCase().endsWith('.kmz')) {
        const JSZip = (await import('jszip')).default;
        const buffer = await res.arrayBuffer();
        const zip = await JSZip.loadAsync(buffer);
        const kmlEntry = Object.values(zip.files).find(f => f.name.endsWith('.kml'));
        if (!kmlEntry) return;
        kmlText = await kmlEntry.async('string');
      } else {
        kmlText = await res.text();
      }

      const doc = new DOMParser().parseFromString(kmlText, 'text/xml');
      const data = toGeoJsonKml(doc) as FeatureCollection;
      if (!cancelled) setGeojson(data);
    }

    load().catch(console.error);
    return () => { cancelled = true; };
  }, [url]);

  return geojson;
}
